import React from 'react'
import styled from 'styled-components'

const PramonImg = styled.img`
  position: absolute;
`

export const Pramon = ({ pramon = null }) => pramon
  ? <PramonImg src={`https://mer.stdout.cz/l.gif?s=pramon&v=1&e=view&t=${pramon}`} alt='pramon'/>
  : null
